<template>
	<div class="w-full !px-2 sm:!px-0">
		<TabGroup :default-index="defaultTab" @change="handleChange">
			<TabList class="flex space-x-1 border-b border-b-zinc-400 w-full overflow-x-scroll no-scrollbar">
				<Tab v-for="tab in tabs" as="button" :key="tab" v-slot="{ selected }" class="flex-1">
					<span
						:class="[
							'flex-1 w-full flex justify-center !py-2 !px-2.5',
							'uppercase text-xs font-medium tracking-wider break-keep whitespace-nowrap',
							selected ? 'border-b-2 border-b-black !opacity-100' : '!pb-2.5 opacity-60 hover:!opacity-100',
						]"
					>
						{{ tab }}
					</span>
				</Tab>
			</TabList>
			<TabPanels>
				<template v-for="slot in Object.keys(slots)">
					<TabPanel :class="['!mb-0 !mt-8', panelStyle]">
						<slot :name="slot" />
					</TabPanel>
				</template>
			</TabPanels>
		</TabGroup>
	</div>
</template>

<script setup>
import { useSlots } from 'vue'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'

const props = defineProps({
	tabs: { type: Array, required: true },
	panelStyle: { type: String, required: false },
	defaultTab: { type: Number, default: 0 },
})

const slots = useSlots()
const emit = defineEmits(['tab-change'])

/**
const isApplicableTab = (slot) => {
	const tabSlotMap = {
		Description: 'description', // css to uppercase
		'Product Info': 'description', // css to uppercase
	}
	if (slot in tabSlotMap) {
		return true
	}
	return false
}
const tranformSlot = (slot) => slot.replace(' ', '-') // fixes bug with slot name with spaces
 */
const handleChange = (tab) => emit('tab-change', props.tabs[tab])
</script>
